// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1vMOs","content":"LayoutSettings_content__31tKC"};